import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ComplianceActionsPanel } from '../features/compliance';
import { RoleGate } from '../shared/components/role-gate';

export function CompliancePage() {
  const { idCuenta } = useParams<{ idCuenta: string }>();
  const { t } = useTranslation(['compliance']);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">{t('compliance:page.title')}</h2>
        <p className="text-sm text-muted-foreground">{t('compliance:page.subtitle')}</p>
      </div>

      {idCuenta ? (
        <RoleGate allow="PSP_ADMIN">
          <ComplianceActionsPanel accountId={idCuenta} />
        </RoleGate>
      ) : (
        <p className="text-sm text-muted-foreground">{t('compliance:page.missingAccount')}</p>
      )}
    </div>
  );
}
